export default __webpack_public_path__ + "static/media/digital-maturity.1f832093.gif";